module.exports = __webpack_public_path__ + "static/img/1.94f0234.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/18/sp/1.png
// module id = yhQj
// module chunks = 0